const bankAccountType = [
  { label: 'IBAN', value: 'IBAN_BIC' },
  { label: 'Konto-Nr. & BLZ', value: 'ACCOUNTNUMBER_BANKCODE' }
]

export default bankAccountType
